// Route path constants for Bloom IQ web application
// This webapp is for the authenticated app (app.bloomiq.io)
// Marketing site pages (home, pricing, about, etc.) are in bloom-website

export const ROUTES = {
  // Authentication routes
  LOGIN: '/login',
  SIGN_UP: '/signup',
  FORGOT_PASSWORD: '/forgot-password',
  EMAIL_VERIFICATION: '/verify-email',
  SIGN_UP_SUCCESS: '/signup-success',
  AUTH_CALLBACK: '/auth/callback',

  // OAuth provider consent screen (public, non-localized).
  // BloomiQ acts as an OAuth provider for the bloom-mcp MCP server via
  // Stytch Connected Apps. Stytch redirects clients to this exact path.
  OAUTH_AUTHORIZE: '/oauth/authorize',

  // Main app routes (protected) - clean root-level paths for subdomain
  DASHBOARD: '/overview',
  BLOOMTERMINAL: '/', // Post-login redirect - goes to Speak with BiQ (root route)
  ANALYTICS: '/analytics',
  LOOKERSTUDIO: '/lookerstudio',
  BIQ: '/biq',
  CHATBOT: '/biq', // Alias for BiQ
  PROCUREMENT: '/produce-planner', // "Produce Planner" — gated by VITE_ENABLE_PROCUREMENT_PLANNER (dev only)

  // Alerts routes
  ALERTS: '/alerts',
  ALERTS_CONFIGURE: '/alerts/configure',
  ALERTS_ENABLED: '/alerts/enabled',
  ALERTS_TRIGGERED: '/alerts/triggered',
  ALERTS_EDIT: '/alerts/edit',

  // Account routes
  ACCOUNT: '/account',
  PRIVACY: '/privacy',
  BILLING: '/billing',
  USAGE: '/usage',
  MEMBERSHIP: '/membership',
  SUBSCRIPTION: '/subscription',

  // Help routes
  FAQ: '/faq',
  CONTACT: '/contact',

  // Map (unified sea tracking + weather)
  MAP: '/map',
  SEA_TRACKING: '/sea-tracking', // Redirect to /map

  // Calendar (if needed)
  CALENDAR: '/calendar',

  // Legal routes (redirects to marketing site)
  LEGAL_TERMS: 'https://bloomiq.io/en/legal/terms/',
  LEGAL_PRIVACY: 'https://bloomiq.io/legal/privacy',
};

// Supported URL locales. Mirrors src/i18n/index.js::supportedLanguageCodes;
// duplicated here to avoid a cross-module cycle.
export const SUPPORTED_LOCALES = ['en', 'es'];
export const DEFAULT_LOCALE = 'en';

// localePath('es', '/login')  → '/es/login'
export function localePath(lang, path) {
  const locale = SUPPORTED_LOCALES.includes(lang) ? lang : DEFAULT_LOCALE;
  const clean = path.startsWith('/') ? path : `/${path}`;
  return `/${locale}${clean}`;
}

// parseLocalePath('/es/login') → { locale: 'es', rest: '/login' }
// parseLocalePath('/login')    → { locale: null, rest: '/login' }
export function parseLocalePath(pathname) {
  const m = pathname.match(/^\/(en|es)(\/.*)?$/);
  if (!m) return { locale: null, rest: pathname };
  return { locale: m[1], rest: m[2] || '/' };
}

// Helper function to check if route is authenticated
export const isAuthRoute = (path) => {
  const { rest } = parseLocalePath(path);
  return [
    ROUTES.LOGIN,
    ROUTES.SIGN_UP,
    ROUTES.FORGOT_PASSWORD,
    ROUTES.EMAIL_VERIFICATION,
    ROUTES.SIGN_UP_SUCCESS,
    ROUTES.AUTH_CALLBACK,
  ].includes(rest);
};

// Helper function to check if route requires authentication
export const isProtectedRoute = (path) => {
  return !isAuthRoute(path);
};
